import { Button } from '@99designs/common/components/Button';
import React from 'react';

interface Props {
    userId: number;
    designId: number;
}

const DesignEditButton = ({ userId, designId }: Props) => (
    <Button
        variations={['secondary', 'fluid']}
        href={`/profiles/${userId}/designs/${designId}/edit`}
    >
        {__('Edit design')}
    </Button>
);

export default DesignEditButton;



// WEBPACK FOOTER //
// ./src/js/components/DesignEditButton.tsx